import { atom, useAtom } from 'jotai';

const boundingBoxAtom = atom(null);

export function useBoundingBox() {
  return useAtom(boundingBoxAtom);
}
